export default __webpack_public_path__ + "static/media/gift-popup.bed03b86.svg";